import React, { useState } from "react";

//* import mui
import { Box, Typography, IconButton } from "@mui/material";
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import CircleIcon from '@mui/icons-material/Circle';

//* import css
import cssClasses from "./NotificationDrawer.module.css";
import Close from "../../Components/Icons/Close";

//* import subComponents
import TabsMenu from '../../Subcomponents/TabsMenu';

import EventUpdateNotification from "./EventUpdateNotification";
import LeadClaimedNotification from "./LeadClaimedNotification";
import LeadConverterNotification from "./LeadConverterNotification";
import FosAddedNotification from "./FosAddedNotification";
import { offlineToast } from "../../Services/Toast";
import { useSelector } from "react-redux";
import { Network } from '@capacitor/network';

const NotificationDrawer = ({ toggleDrawer, clearEventNotification, clearLeadNotification, clearFosNotification, countObject }) => {

  const loggedInUser = useSelector((state) => state.Auth.user);

  const [selectedTab, setSelectedTab] = useState("Event Updates");


  console.log("loggedInUser", loggedInUser);

  return (
    <Box
      // sx={{ width: {xs: "100%", sm: "100%", md: "70rem", lg: "70rem", xl: "70rem"} }}
      role="presentation"
      // onClick={() => toggleDrawer(false)}
      // onKeyDown={() => toggleDrawer(false)}
      display={"flex"}
      flexDirection={"column"}
      // padding={"2.5rem"}
      height={"100%"}
    >
      <div className={cssClasses.headerWrapper}>
        <Typography fontSize={"2.5rem"} fontFamily={"'Inter-Medium' !important"}>Notifications</Typography>
        <IconButton onClick={() => toggleDrawer(false)}>
          <Close width={"2rem"} height={"2rem"} />
        </IconButton>
      </div>

      <Box className={cssClasses.TabsWrapper}>
        <TabContext value={selectedTab}>
          <TabsMenu
            // selectedColor={"#FFFFFF"}
            // selectedBackgroundColor={"#175cd3"}
            stylesForTab={{
              color: '#667085',
              fontSize: '1.4rem',
              fontStyle: 'normal',
              fontWeight: '500',
              lineHeight: '2rem',
              padding: "0.8rem 1.2rem",
              textTransform: 'unset',
              // borderBottom: "1px solid #EAECF0"
            }}
            borderColor={"#175cd3"}
            // borderColor={"#FFFFFF"}
            stylesForWrapper={{
              padding: "0.5rem 0",
              background: "#F9FAFB",
            }}
            list={
              //**removed condition for entity */ && loggedInUser.cpType === "Entity"
              mainTabs.map(m => ({ ...m, text: countObject[m.countKey] ? <p>{m.text} <span style={{color: "#175cd3", marginLeft: "0.5rem"}}>({countObject[m.countKey]})</span></p> : m.text })).filter(f => f.value === "FOS Updates" ? (loggedInUser.type === "CP" ) : true)
            }
            value={selectedTab}
            handleChange={(e, value) => {
              // e.preventDefault();
              // onTabChange(value);
              Network.getStatus().then((resp) => {
                if (!resp.connected) {
                offlineToast();
                return;
              }
              setSelectedTab(value);
            });
            }}
          />
          <TabPanel className={cssClasses.tabPanel} value={"Event Updates"} index={0}>
            <Box className={cssClasses.mainTabPanelWrapper}>
              <EventUpdateNotification clearEventNotification={clearEventNotification} />
            </Box>
          </TabPanel>
          <TabPanel className={cssClasses.tabPanel} value={"Lead Updates"} index={1}>
            <Box className={cssClasses.mainTabPanelWrapper}>
              <LeadClaimedNotification clearLeadNotification={clearLeadNotification} />
            </Box>
          </TabPanel>
          <TabPanel className={cssClasses.tabPanel} value={"Leads Converted"} index={2}>
            <Box className={cssClasses.mainTabPanelWrapper}>
              <LeadConverterNotification clearLeadNotification={clearLeadNotification} />
            </Box>
          </TabPanel>
          <TabPanel className={cssClasses.tabPanel} value={"FOS Updates"} index={3}>
            <Box className={cssClasses.mainTabPanelWrapper}>
              <FosAddedNotification clearFosNotification={clearFosNotification} />
            </Box>
          </TabPanel>
          
        </TabContext>
      </Box>

    </Box>
  );
};

export default NotificationDrawer;

const mainTabs = [
  { text: "Event Updates", value: "Event Updates", countKey: "eventNotificationCount"},
  { text: "Lead Updates", value: "Lead Updates", countKey: "leadNotificationCount"},
  { text: "Leads Converted", value: "Leads Converted", countKey: "leadNotificationCount"},
  { text: "FOS Updates", value: "FOS Updates", countKey: "fosNotificationCount"},
];


// function EventUpdateNotification() {

//   return (
//     <div className={cssClasses.notificationContainerWrapper}>
//       {
//         Array(10).fill("").map((notificationItem, notificationIndex) => (
//           <div key={`notification_${notificationIndex}`} className={cssClasses.notificationContainer}>
//             <div className={cssClasses.notificationAvatarWrapper}><Avatar src="" /></div>
//             <div className={cssClasses.notificationTextWrapper}>
//               <p className={`${cssClasses.notificationText} ${cssClasses.notificationHeaderText}`}>YashOne Event <span className={`${cssClasses.notificationText} ${cssClasses.notificationTimeText}`}>2 mins ago</span></p>
              
//               <p className={`${cssClasses.notificationText} ${cssClasses.notificationSubHeaderText}`}>New Event Added</p>
//               <p className={`${cssClasses.notificationText} ${cssClasses.notificationDescriptionText}`}>“YashOne added as a New event recently. Please check the details”</p>
//             </div>
//             <div>
//               <CircleIcon style={{color: "#12B76A"}}/>
//             </div>
//           </div>
//         ))
//       }
//     </div>
//   )
// }
// function EventLeadClaimedNotification() {

//   return (
//     <div className={cssClasses.notificationContainerWrapper}>
//       {
//         Array(10).fill("").map((notificationItem, notificationIndex) => (
//           <div key={`notification_${notificationIndex}`} className={cssClasses.notificationContainer}>
//             <div className={cssClasses.notificationAvatarWrapper}><Avatar src="" /></div>
//             <div className={cssClasses.notificationTextWrapper}>
//               <p className={`${cssClasses.notificationText} ${cssClasses.notificationHeaderText}`}>YashOne Event <span className={`${cssClasses.notificationText} ${cssClasses.notificationTimeText}`}>2 mins ago</span></p>
              
//               <p className={`${cssClasses.notificationText} ${cssClasses.notificationSubHeaderText}`}>New Event Added</p>
//               <p className={`${cssClasses.notificationText} ${cssClasses.notificationDescriptionText}`}>“YashOne added as a New event recently. Please check the details”</p>
//             </div>
//             <div>
//               <CircleIcon style={{color: "#12B76A"}}/>
//             </div>
//           </div>
//         ))
//       }
//     </div>
//   )
// }
// function EventLeadConverterNotification() {

//   return (
//     <div className={cssClasses.notificationContainerWrapper}>
//       {
//         Array(10).fill("").map((notificationItem, notificationIndex) => (
//           <div key={`notification_${notificationIndex}`} className={cssClasses.notificationContainer}>
//             <div className={cssClasses.notificationAvatarWrapper}><Avatar src="" /></div>
//             <div className={cssClasses.notificationTextWrapper}>
//               <p className={`${cssClasses.notificationText} ${cssClasses.notificationHeaderText}`}>YashOne Event <span className={`${cssClasses.notificationText} ${cssClasses.notificationTimeText}`}>2 mins ago</span></p>
              
//               <p className={`${cssClasses.notificationText} ${cssClasses.notificationSubHeaderText}`}>New Event Added</p>
//               <p className={`${cssClasses.notificationText} ${cssClasses.notificationDescriptionText}`}>“YashOne added as a New event recently. Please check the details”</p>
//             </div>
//             <div>
//               <CircleIcon style={{color: "#12B76A"}}/>
//             </div>
//           </div>
//         ))
//       }
//     </div>
//   )
// }
// function EventFosAddedNotification() {

//   return (
//     <div className={cssClasses.notificationContainerWrapper}>
//       {
//         Array(10).fill("").map((notificationItem, notificationIndex) => (
//           <div key={`notification_${notificationIndex}`} className={cssClasses.notificationContainer}>
//             <div className={cssClasses.notificationAvatarWrapper}><Avatar src="" /></div>
//             <div className={cssClasses.notificationTextWrapper}>
//               <p className={`${cssClasses.notificationText} ${cssClasses.notificationHeaderText}`}>YashOne Event <span className={`${cssClasses.notificationText} ${cssClasses.notificationTimeText}`}>2 mins ago</span></p>
              
//               <p className={`${cssClasses.notificationText} ${cssClasses.notificationSubHeaderText}`}>New Event Added</p>
//               <p className={`${cssClasses.notificationText} ${cssClasses.notificationDescriptionText}`}>“YashOne added as a New event recently. Please check the details”</p>
//             </div>
//             <div>
//               <CircleIcon style={{color: "#12B76A"}}/>
//             </div>
//           </div>
//         ))
//       }
//     </div>
//   )
// }